export function parseTagInput(value: string): string[] {
  const tags = value
    .split(",")
    .map((tag) => tag.trim())
    .filter(Boolean);
  return Array.from(new Set(tags));
}

export function formatTagInput(tags: string[]): string {
  return tags.join(", ");
}
